import { render, staticRenderFns } from "./SIKeuangan.vue?vue&type=template&id=6aba1714&"
import script from "./SIKeuangan.vue?vue&type=script&lang=js&"
export * from "./SIKeuangan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports